module.exports = __webpack_public_path__ + "media/customizations/valenciatrails/logo-6921f223e3eff8e570990ee8ab4e15c0.png";